import { ResponsiveFloraTypography, Skeleton, Text } from 'ui/components/primitives';

import { Styles, SkeletonStyles } from './Combo.styles';
import ComponentsStyles from './components/Combo.components.styles';
import { SkeletonCard } from '../Product/ProductCard/ProductCard.styles';

export const ComboSkeleton = () => (
  <Styles.Wrapper>
    <ComponentsStyles.Combo>
      <SkeletonCard.Card data-radius="rounded" spacing="small">
        <SkeletonCard.Image>
          <Skeleton />
        </SkeletonCard.Image>

        <SkeletonCard.Code>
          <Skeleton />
        </SkeletonCard.Code>

        <ResponsiveFloraTypography as="h6" fontSize="subtitle">
          <Skeleton />
        </ResponsiveFloraTypography>

        <div>
          {[...Array(3)].map((_value, index) => (
            <SkeletonStyles.PriceInfo key={index}>
              <Skeleton />
            </SkeletonStyles.PriceInfo>
          ))}
        </div>

        <ComponentsStyles.Divider />

        <Text>
          <Skeleton />
        </Text>
        <SkeletonStyles.QuantitySelector>
          <Skeleton />
        </SkeletonStyles.QuantitySelector>

        <ComponentsStyles.Divider />

        <SkeletonCard.Button>
          <Skeleton />
        </SkeletonCard.Button>
      </SkeletonCard.Card>
    </ComponentsStyles.Combo>
    <Styles.Options>
      {[...Array(4)].map((_value, index) => (
        <ComponentsStyles.Skus key={`combo-skeleton-structure-${index}`}>
          <ResponsiveFloraTypography as="h6" fontSize="subtitle">
            <Skeleton />
          </ResponsiveFloraTypography>

          <SkeletonCard.Code>
            <Skeleton />
          </SkeletonCard.Code>

          <SkeletonStyles.Wrapper>
            {[...Array(4)].map((_, i) => (
              <ComponentsStyles.Sku key={`combo-skeleton-options-${i}`} spacing="small">
                <SkeletonStyles.Image>
                  <Skeleton />
                </SkeletonStyles.Image>
                <Text>
                  <Skeleton />
                </Text>

                <SkeletonStyles.Button>
                  <Skeleton />
                </SkeletonStyles.Button>
              </ComponentsStyles.Sku>
            ))}
          </SkeletonStyles.Wrapper>
        </ComponentsStyles.Skus>
      ))}
    </Styles.Options>
  </Styles.Wrapper>
);
